// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nv-0";